import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  popoverContent: {
    background: 'transparent',
    boxShadow: 'none',
    borderRadius: '12px',
    display: 'flex',
    position: 'absolute',
    right: '20px',
    left: 'unset !important',
    maxWidth: '508px',
    top: '62px !important',
    height: 'fit-content',
    '&.MuiPopover-paper': {
      overflowY: 'hidden',
    },

    '&::before': {
      background: theme.new.color.pageBackground,
      borderRadius: 'inherit',
      filter: 'blur(20px)',
      content: '""',
      inset: '0',
      maxHeight: 'inherit',
      opacity: 0.9,
      position: 'absolute',
      zIndex: '-2',
    },

    [theme.breakpoints.down('md')]: {
      bottom: '0',
    },
  },
  alertRedCircleIcon: {
    position: 'absolute',
    right: '6px',
    top: '9px',
  },
  notificationIconButton: {
    '&:active': {
      stroke: `${theme.new.color.textPrimary} !important`,
    },

    '&:active, &.selected': {
      backgroundColor: `${theme.new.color.brand[200]} !important`,

      circle: {
        stroke: theme.new.color.brand[200],
      },
    },
  },
}));

export default useStyles;
